import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import radio from '@/lib/radio.js'
import options from '@/lib/options.js'
import getProductJson from '@/lib/getProductJson.js'

import '@/lib/jquery-global.js'
import 'slick-carousel'

export default component(({ node }) => {
  const opts = options(node)

  jQuery('.js-pdp-slider').slick({
    dots: false,
    arrows: false,
    draggable: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          adaptiveHeight: true,
          dots: true
        }
      }
    ]
  });

  jQuery('.js-thumbnail').click(function() {
    jQuery('.js-slider-' + jQuery(this).data('id')).slick('slickGoTo', jQuery(this).data('index'));
    jQuery(this).addClass('active');
  });

  jQuery('.js-pdp-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    jQuery('.js-thumbnail-' + jQuery(this).data('id')).removeClass('active');
    jQuery('.js-thumbnail-' + jQuery(this).data('id') + '[data-index="' + nextSlide + '"]').addClass('active');
  });

  // cache
  getProductJson()

  opts.onUpdate(state => {
    getProductJson().then(json => {
      const variant = json.variants.filter(v => v.id == state.id)[0]
    })
  })
  
})
